import Layout from '../shared/Layout';
import PageHeader from '../shared/PageHeader';
import { useContext, useEffect } from 'react';
import DetailsContext from '../../providers/DetailsContext';
import language from '../../variables/language';
import { useNavigate } from 'react-router-dom';
import DailySchedule from './DailySchedule';
// import LastConversationProgress from './LastConversationProgress';
import RecentHomework from './RecentHomework';
import LessonsWithoutHomework from './LessonsWithoutHomework';
import ChatesContainer from './ChatesContainer';
import TelegramUsageChart from './TelegramUsageChart';
import PendingApprovalsPanel from './PendingApprovalsPanel';
import '../../css/dashboard.css';

const Dashboard = () => {
   const lang = language[language.lang];
   const { isLoggedIn } = useContext(DetailsContext);
   const navigate = useNavigate();

   useEffect(() => {
      if (isLoggedIn === false) {
         navigate('login');
      }
   }, [isLoggedIn, navigate]);

   return (
      <Layout>
         
         <main className='main-block'>
            <div className='main-content dashboard-page'>
               <DailySchedule />
               <ChatesContainer />
               <div className='dashboard-columns'>
                  {/* <LastConversationProgress /> */}
                  <div className='dashboard-column-stack'>
                     <RecentHomework />
                     <LessonsWithoutHomework />
                  </div>
                  <div className='dashboard-column-stack'>
                     <TelegramUsageChart />
                     <PendingApprovalsPanel />
                  </div>
               </div>
            </div>
         </main>
      </Layout>
   );
};

export default Dashboard;
